<template>
  <div>
    <v-container fluid grid-list-sm style="background-color: transparent">
      <v-layout row wrap>
        <v-flex 
          xs12 md3 
          :class="{ 'pa-0 pb-4': $vuetify.breakpoint.smAndUp }" 
          v-for="post in list" 
          :key="post.id"
        >
          <moment-card :post="post" />
        </v-flex>
      </v-layout>
    </v-container>

    <infinite-loading @infinite="infiniteHandler">
      <div slot="spinner">Cargando...</div>
      <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
      <v-layout slot="no-results">
        <v-flex sm12>
          <v-card height="400px">
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex
                sm12
                class="text-29-security text-md-center font-weight-bold"
                style="color: #525252"
              >No hay más momentos de esta categoría</v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </infinite-loading>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import MomentCard from "./MomentCard";

export default {
  components: {
    MomentCard,
  },
  props: {
    category: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      page: 1,
      list: []
    };
  },
  methods: {
    ...mapMutations("posts", ["setPost", "setPosts"]),
    infiniteHandler($state) {
      let api = `${process.env.VUE_APP_API_URL}/posts_video`;
      axios.get(api, {params: {page: this.page, view_as: localStorage.getItem("view_as"), category: this.category}})
      .then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.list.push(...data.hits);
          this.setPosts(this.list);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }
};
</script>